import { Avatar } from "@mui/material";
import React, { useEffect, useState } from "react";
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from "react-icons/md";
import Colors from "../../constants/Colors";
import {
  ScheduleDay,
  ScheduleTimeAvailableData,
} from "../../core/http/service/SchedulingService";
import useFetchPhoto from "../../hooks/useFetchPhoto";
import useResponsiveInfo from "../../hooks/useResponsiveInfo";
import { Span, SubTitleSimple, Text } from "../UI/generalLayout/Layout.styled";
import { Spacer } from "../UI/spacer/spacer";
import DaySchedulingCard from "./DaySchedulingCard/DaySchedulingCard";
import ModalSchedulingCard from "./ModalSchedulingCard/ModalSchedulingCard";
import {
  Card,
  MedicCardContainer,
  ViewAllSchedulingCard,
} from "./SchedulingCard.style";

// import { Container } from './styles';

export interface AttendantSchedulingCardProps {
  data: ScheduleTimeAvailableData;

  dias: ScheduleDay[];
  nome: string;
}

const AttendantSchedulingCard: React.FC<AttendantSchedulingCardProps> = ({
  dias,

  data,
  nome,
}) => {
  const [showableDays, setShowableDays] = useState<ScheduleDay[]>([]);
  const [openMoreDays, setOpenMoreDays] = useState(false);
  const [photo, setPhoto] = useState<any>()
  const { isMobile } = useResponsiveInfo();

  useEffect(() => {
    if (!openMoreDays && dias.length > 1) {
      setShowableDays([dias[0]]);
    } else {
      setShowableDays(dias);
    }
  }, [dias, openMoreDays]);

  useFetchPhoto(data.foto ?? null, setPhoto);

  return (
    <>
      <Card>
        <MedicCardContainer key={data.id}>
          <Avatar src={photo} sx={{ width: 55, height: 55 }} />
          <div>
            <Text color={Colors.SPM800} bold>
              {data.nome}
            </Text>
            <SubTitleSimple color={Colors.GRAY700}>
              {data.tipoProfissional}
            </SubTitleSimple>
          </div>

          {isMobile ? null : <Span color={Colors.SPM800}>{nome}</Span>}
        </MedicCardContainer>
        {showableDays.map((dia) => (
          <DaySchedulingCard
            day={dia}
            scheduleTimeAvailableData={data}
            key={dia.dia}
          />
        ))}
        {dias.length > 1 ? (
          <ViewAllSchedulingCard
            onClick={() => setOpenMoreDays((value) => !value)}
          >
            {openMoreDays ? (
              <>
                Ver menos horários <MdKeyboardArrowUp />
              </>
            ) : (
              <>
                Ver mais horários <MdKeyboardArrowDown />
              </>
            )}
          </ViewAllSchedulingCard>
        ) : null}
        <ModalSchedulingCard />
      </Card>
      <Spacer bottom={10} />
    </>
  );
};

export default AttendantSchedulingCard;
